var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwimmingPool(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#666"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.375 19.434s1.431.887 2.547 0 2.003.223 2.519.197c.514-.025 1.259-1.057 2.088-.541.83.516 2.055.853 2.776.297 1.059-.815 1.723-.314 2.518.133 1.053.59 1.545-1.002 2.89-.315 1.346.687 1.975.62 2.662.182M3.375 16.434s1.431.887 2.547 0 2.003.223 2.519.197c.514-.025 1.259-1.057 2.088-.541.83.516 2.055.853 2.776.297 1.059-.815 1.723-.314 2.518.133 1.053.59 1.545-1.002 2.89-.315 1.346.687 1.975.62 2.662.182M5.64 14.87V8.7a3.825 3.825 0 017.125-1.936",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.375 14.87V8.7a3.825 3.825 0 117.65 0v.834",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.64 12.751h6.735v-2.88H5.64z"
  })))));
}
export default SvgSwimmingPool;